import React, { Suspense } from 'react';
import * as Sentry from '@sentry/react';
import { observer } from 'mobx-react';

import 'tailwindcss/dist/base.min.css';

import { LoadingView } from '@nw/shared/ui';
import {
  addLogEntriesScriptAndInitializeLogEntries,
  initializeSentry
} from '@nw/shared/utils';

import ErrorBoundaryFallback from '../components/ErrorBoundaryFallback';

import App from './app';

import '../index.css';
import { APP_CONTEXTUAL_LOADING_CONFIG } from '../constants/ContextualLoadingConstants';

declare global {
  interface Window {
    dataLayer: any;
    analytics: any;
    mixpanel: any;
    R7Insight: any;
  }
}

@observer
class EnhancedApp extends React.Component {
  constructor(props) {
    super(props);
    initializeSentry();
    window.addEventListener('load', this.onPageLoad);
  }

  componentWillUnmount() {
    window.removeEventListener('load', () => null);
  }

  onPageLoad = (): void => {
    addLogEntriesScriptAndInitializeLogEntries();
  };

  render() {
    return (
      <Sentry.ErrorBoundary fallback={ErrorBoundaryFallback}>
        <Suspense fallback={<LoadingView loadingConfig={APP_CONTEXTUAL_LOADING_CONFIG} /> as any}>
          <App />
        </Suspense>
      </Sentry.ErrorBoundary>
    );
  }
}

export default EnhancedApp;
